import api from './api';

export const createQuestion = async data => {
  try {
    const response = await api.post(`/questions/add`, data);
    return response.data;
  } catch (error) {
    console.error(
      'Error al crear la encuesta:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

export const updateQuestion = async (id, data) => {
  try {
    const response = await api.put(`/questions/update/${id}`, data);
    return response.data;
  } catch (error) {
    console.error(
      'Error al crear la encuesta:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

export const getById = async id => {
  try {
    const response = await api.get(`/questions/getById/${id}`);
    return response.data;
  } catch (error) {
    console.error(
      'Error al crear la encuesta:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

export const remove = async id => {
  try {
    const response = await api.delete(`/questions/remove/${id}`);
    return response.data;
  } catch (error) {
    console.error(
      'Error al eliminar la encuesta:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};
